/* eslint-disable import/no-unresolved */
import { isEmpty } from 'lodash';
import ProductOffer from 'model/ProductOffer';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as sessionSelectors from 'store/state/session/sessionSelectors';

/**
 * Hook para calcular o valor do frete baseado na filial do cliente selecionado
 *
 * Implementa a mesma lógica do ProductCardActions.tsx e ProductShippingFee.tsx para garantir
 * consistência entre todos os layouts de ProductCard
 * alteração baseada no pr https://dev.azure.com/veiling/Veiling%20Online/_git/Veiling.Ecommerce.Frontend/pullrequest/12813
 */
export function useShippingFee(product: ProductOffer): {
  shippingFee: number;
  hasShippingFee: boolean;
} {
  const selectedCustomerId = useSelector(
    sessionSelectors.getSelectedCustomerId,
  );
  const { customers } = useSelector(sessionSelectors.getRoot);

  const selectedCustomer = useMemo(
    () => customers?.find((customer) => customer.id === selectedCustomerId),
    [customers, selectedCustomerId],
  );

  const shippingCalculation = useMemo(() => {
    // Verifica se existem filiais de frete configuradas
    if (isEmpty(product?.shippingFeeFilials)) {
      return { shippingFee: 0, hasShippingFee: false };
    }

    // Busca o frete específico para a filial do cliente
    const customerShippingFee = product.shippingFeeFilials.find(
      (fee) => fee.organizationName === selectedCustomer?.branch,
    );

    if (customerShippingFee?.productShippingValue) {
      // Never round here: the fee carries up to 6 decimals and every total is
      // built from this exact value.
      return {
        shippingFee: customerShippingFee.productShippingValue,
        hasShippingFee: true,
      };
    }

    // frete só deve ser exibido para filiais específicas de Uberlândia
    return { shippingFee: 0, hasShippingFee: false };
  }, [product.shippingFeeFilials, selectedCustomer?.branch]);

  return shippingCalculation;
}
